import { useTranslation } from "react-i18next";
import {
  useAuthentication,
  useRetrieveCurrentPlanzone,
  useRetrieveSecondaryCriteriaTemplate,
  useRetrieveTimeRecordsListingConfiguration,
} from "@planzone/view-models";

const fixedColumns = [
  "date",
  "resourceTask",
  "project",
  "timeSpent",
  "validation",
];

function useTimeRecordsListingColumns() {
  const { t, i18n } = useTranslation();
  const { account } = useAuthentication();
  const { planzone } = useRetrieveCurrentPlanzone();
  const { configuration } =
    useRetrieveTimeRecordsListingConfiguration(planzone);
  const { template } = useRetrieveSecondaryCriteriaTemplate(
    planzone.uuid,
    "timeRecord",
  );
  const currentLang =
    ["fr", "en"].find((lang) => new RegExp(lang, "i").test(i18n.language)) ||
    "fr";
  const role = account.resource?.role;
  const matchedProfile = configuration.find(
    (profile) =>
      !!role && profile.roles.find((r) => r === role.name || r === role.uuid),
  );
  const columns = (
    matchedProfile
      ? matchedProfile.columns
      : fixedColumns.map((key) => ({ key }))
  ).filter(
    ({ key }) =>
      fixedColumns.includes(key) || template.find(({ uuid }) => uuid === key),
  );

  return {
    columns,
    template,
    label: (key: string) => {
      const criteria = template.find(({ uuid }) => uuid === key);

      return criteria
        ? criteria.labels[currentLang as keyof typeof criteria.labels] ||
            criteria.name
        : t(`weekTimeRecords.columns.${key}`, key);
    },
  };
}

export { useTimeRecordsListingColumns, fixedColumns };
